import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';

const Marker = ({ color }) => (
  <div
    className="pin"
    style={{ backgroundColor: color, cursor: 'pointer' }}
  />
);

const ShowGoogleMap = ({ latitude, longitude, googleMapApiKey }) => {
  const defaultProps = {
    center: {
      lat: latitude,
      lng: longitude,
    },
    zoom: 15,
  };

  const getMapOptions = () => ({
    mapTypeControl: true,
    streetViewControl: true,
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'on' }],
      },
    ],
  });

  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: googleMapApiKey }}
      defaultCenter={defaultProps.center}
      defaultZoom={defaultProps.zoom}
      options={getMapOptions}
    >
      <Marker lat={latitude} lng={longitude} color="red" />
    </GoogleMapReact>
  );
};

Marker.propTypes = {
  color: PropTypes.string.isRequired,
};

ShowGoogleMap.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
};

export default ShowGoogleMap;
